// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsSidebar-cls1_EiV","cls2":"ToolsSidebar-cls2__1T ToolsSidebar-cls1_EiV"};